<div class="pageheader">
    <div class="page-title">
        <h1>Users</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        </div>
    </div>
</div>
<div class="btn-toolbar">
    <div class="btn-group">
        <button id="btnShowUsers" class="btn btn-primary btn-sm" *bizPermissionRequired="'Users_View_UserDetails'" [disabled]="!selectedUsers || selectedUsers.length === 0" (click)="showUsers()">Show Users</button>
    </div>
    <div class="btn-group">
        <button id="btnNewUser" class="btn btn-primary btn-sm" *bizPermissionRequired="'User_Action_UserCreate'" (click)="newUser()">New User</button>
    </div>
</div>
<dx-data-grid biz-grid
              (rowDoubleClick)="rowDoubleClicked($event)"
              stateStorageKey="userListStateStorageKey"
              (onSelectionChanged)='selectionChanged($event)'
              [selection]='{ mode: "multiple" }'
              [dataSource]='users'
              [showIsLoading]="isLoading"
              [columns]="[
                         {
                              caption: 'User Id',
                              dataField: 'UserId',
                              dataType: 'number',
                              width: 150,
                              visible: false
                          },
                          {
                              caption: 'Display Name',
                              dataField: 'DisplayName',
                              dataType: 'string',
                              sortOrder: 'asc'
                          },
                          {
                              caption: 'Username',
                              dataField: 'Credentials.UserName',
                              dataType: 'string'
                          },
                          {
                              caption: 'Email',
                              dataField: 'EmailAddress',
                              dataType: 'string'
                          },
                          {
                              caption: 'Last Activity',
                              dataField: 'LastActivity',
                              dataType: 'datetime',
                              format: 'yyyy-MM-dd',
                              width: 150,
                          },
                          {
                              caption: 'Disabled',
                              dataField: 'IsDisabled',
                              dataType: 'boolean',
                              width: 100
                          },
                          {
                              caption: 'BuiltIn',
                              dataField: 'IsBuiltIn',
                              dataType: 'boolean',
                              width: 100
                          }
                        ]"
              [masterDetail]="{
                              enabled: true,
                              template: 'userGroupsTemplate'
                        }">
    <div *dxTemplate="let user of 'userGroupsTemplate'">
        <div>
            <label>Usergroups:</label>
            <dx-data-grid
				[dataSource]='user.data.UserGroups'
				[columnAutoWidth]='true'
                [columns]='[
                    {
                        dataField: "Name",
                        caption: "Usergroup",
                        dataType: "string",
                        sortOrder: "asc"
                    },
                    {
                        dataField: "Description",
                        caption: "Description",
                        dataType: "string"
                    }]'>
            </dx-data-grid>
        </div>
    </div>
</dx-data-grid>
